import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

const EndNotes = ({ lastUpdatedAt, finnkode, externalAdId }) => {
    const lastUpdated = moment(lastUpdatedAt).locale('no').format('D. MMM YYYY HH:mm');

    return (
        <div className="py-32" role="region">
            <h2 aria-hidden="false" className="sr-only">
                Annonseinformasjon
            </h2>

            <table className="mb-0">
                <tbody>
                    <tr>
                        <th className="pr-16">FINN-kode</th>
                        <td>{finnkode}</td>
                    </tr>
                    <tr>
                        <th className="pr-16">Sist endret</th>
                        <td>{lastUpdated}</td>
                    </tr>
                    {externalAdId && (
                        <tr>
                            <th className="pr-16">Referanse</th>
                            <td>{externalAdId}</td>
                        </tr>
                    )}
                </tbody>
            </table>

            <div className="mt-16">
                <a data-controller="trackReportAdClick" href={`/reportad.html?finnkode=${finnkode}`} rel="external">
                    Rapporter annonse
                </a>
            </div>

            <p className="text-12">
                Annonsene kan være mangelfulle i forhold til lovpålagt opplysningsplikt. Før bindende avtale inngås
                oppfordres interessenter til å innhente komplett informasjon fra meglerforetaket, selger eller utleier.
            </p>
        </div>
    );
};

EndNotes.propTypes = {
    lastUpdatedAt: PropTypes.string,
    finnkode: PropTypes.number,
    externalAdId: PropTypes.string,
};

export default EndNotes;
